/**
 * Feature flags — driven by VITE_ environment variables so they can be
 * toggled per-environment without code changes.
 */
export const ENABLE_GIFT_CARDS =
  import.meta.env.VITE_ENABLE_GIFT_CARDS_REDEEM === 'true';
